import { AttachmentModel } from "./QueryAttachmentModel";

export class QueryDetailModel
{
    
    Clarification_Query_Detail_Code : number = 0;
    Clarification_Query_Code : number = 0;
    Query_Reference_Number : string = '';
    Is_Confidential : boolean = false;
    PriorityLevel_Id : number = 0;
    Clarification_Cat_Code : string = '';
    Clarification_SubCat_Code : string = '';
    Contract_Number : string = '';
    AFE_Number : string = '';
    Work_Order_Number  : string = '';
    SIOP_Number : string = '';
    LetterReference_Number : string = '';
    Block_Code : number = 0;
    Department_Code  : string = '';
    Sub_Dept_Code : string = '';
    Category_Comments : string = '';
    Company_Restricted : boolean = false;
    Partner_Comment : string = '';
    Comment : string = '';
    CCUsers : [] = [];
    CCDepartments : [] = [];
    CCSubDepartments : [] = [];
    CCEmails : string = '';
    Resolution_Comment : string = '';
    ConsolidatedComment : string[] = [];
    ConsolidatedCommentInString : string = '';
    RequestorName : string = '';
    CompanyName : string = '';
    Block : string = '';
    Department : string = '';
    SubDepartment : string = '';
    Category : string = '';
    SubCategory : string = '';
    PriorityLevel : string = '';
    Active : boolean = false;
    Modified_By : string = '';
    RequestDate: Date = new Date();
    CompletionDate : Date = new Date();
    FileAttachments : AttachmentModel[] = [];
    QueryDetailStatus : number = 0;
    Delete_Comment : string = '';
}